import { apiRequest, createMutationIdempotencyKey } from '../http.js'

export const feedbackApi = {
submit: async (body, options = {}) => {
      return apiRequest('/feedback', {
        ...options,
        method: 'POST',
        body: JSON.stringify(body),
        idempotencyKey: createMutationIdempotencyKey('feedback-submit'),
      })
    },
}
